<template>
    <div id="fusion_rey_welcome_container" class="h-full">
      <div class="welcome-screen content-container flex flex-col h-full w-full relative overflow-hidden shrink-0 items-center justify-center bg-surface-1"
           :class="{ 'welcome-screen--closing': closing }" @transitionend="onWelcomeTransitionEnd">
        <div class="middle-cell w-full flex flex-col items-center justify-center pt-8">
          <div class="w-full flex-1 inline-flex flex-col justify-center items-center gap-12 overflow-hidden">
            <div class="self-stretch flex-1 flex flex-col justify-center items-center overflow-hidden">
              <div class="self-stretch px-4 inline-flex justify-center items-center gap-2.5 pb-8">
                <div class="w-80 text-center text-text-link text-4xl font-extrabold leading-10">{{ $t('rey.welcome.greeting', { name: display_name }) }}</div>
              </div>
              <div class="self-stretch inline-flex justify-center items-center gap-2.5 pb-6">
                <div class="w-56 self-stretch text-center text-text-link text-base leading-5">{{ $t('rey.welcome.prompt') }}</div>
              </div>
              <div v-if="false" class="self-stretch px-1 flex flex-col justify-start items-center gap-4 overflow-y-auto max-h-[60vh]">
                <div class="self-stretch py-4 flex flex-col justify-start items-center gap-3">
                  <div v-for="(suggestedMessage, index) in suggested_messages" @click="sendMessage(suggestedMessage)" :class="index<3 || show_more_messages?'inline-flex':'hidden'"
                       class="px-5 py-2.5 bg-transparent rounded-[100px] outline outline-1 outline-offset-[-1px] outline-brand-outline justify-center items-center gap-2 cursor-pointer hover:bg-brand-subtle transition-colors">
                    <div class="text-center text-text-link text-base font-semibold leading-5">{{ suggestedMessage }}</div>
                  </div>
                </div>
              </div>
              <div v-if="false && suggested_messages.length>3 && !show_more_messages" class="self-stretch py-2.5 inline-flex justify-center items-center gap-2">
                <div class="inline-flex flex-col justify-center items-center cursor-pointer hover:bg-brand-subtle px-3 py-2 rounded-lg transition-colors group" @click="show_more_messages=true">
                  <div class="text-center text-text-link group-hover:text-text-link text-base leading-5">{{ $t('rey.welcome.seeMore') }}</div>
                  <i class="ri-arrow-down-s-line ri-xl text-text-link group-hover:text-text-link" />
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="bottom-cell text-left w-full relative">
          <messenger-input key="fusion_rey_welcome_message_input" mode="WELCOME" :input-config="input_config" :message-input-ready="!is_read_only" @commitInput="sendMessage" @inputFocus="handleInputFocus" @voiceTranscribed="onVoiceTranscribed" />
        </div>
        
        <div class="absolute w-6 h-6 !m-0 top-4 right-1 flex-shrink-0 z-[5]">
          <i class="ri-close-circle-line ri-xl cursor-pointer" @click="startClosing" />
        </div>
      </div>
    </div>
</template>

<style lang="scss">
.welcome-screen {
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;

  &.welcome-screen--closing {
    transform: translateX(-100%);
  }

  #messenger_message_box {
    border: 1px solid var(--border-separator) !important;
    border-radius: 4px !important;
  }
}
</style>
<script>
  import MessengerInput from '@components/Messaging/MessengerInput.vue';
  
  import { mapStores } from 'pinia';
  import { useMainStore } from '@store/main';

  export default {
    components: {
      'messenger-input': MessengerInput,
    },
    created() {
      this.getObjectThreads();
    },
    data() {
      return {
        closing: false,
        show_more_messages: false,
        voice_initiated: false,
        suggested_messages: [
          'How did we do last month?',
          'What vehicles should I buy at auction tomorrow?',
          'Show me average used car F&I gross for last month.',
          'Where am I the most overstocked or understocked?',
          'Show me current receivables for CIT.',
          'Who is my top salesperson?'
        ]
      }
    },
    computed: {
      ...mapStores(useMainStore),
      user_access_info() {
        return this.mainStore.user_access_info;
      },
      display_name() {
        return this.user_access_info?.displayName || this.$t('common.unknownUser');
      },
      object_threads: {
        get() {
          return this.mainStore.object_threads;
        },
        set(value) {
          this.mainStore.object_threads = value;
        }
      },
      object_threads_processing: {
        get() {
          return this.mainStore.object_threads_processing;
        },
        set(value) {
          this.mainStore.object_threads_processing = value;
        }
      },
      is_read_only() {
        return this.mainStore.is_read_only;
      },
      input_config() {
        return {
          placeholder: this.$t('rey.welcome.inputPlaceholder'),
          bottomButtons: false,
          send1: true,
        };
      }
    },
    methods: {
      startClosing() {
        this.closing = true;
      },
      onWelcomeTransitionEnd(event) {
        if (event.target === event.currentTarget && event.propertyName === 'transform' && this.closing)
          this.$emit('closeWelcome');
      },
      sendMessage(message='') {
        let newMessage = message;
        if(!newMessage) {
          const content = message || this.$refs.messenger_input;
          newMessage = content.textContent;
        }
        if(newMessage && newMessage.trim()) {
          if (this.voice_initiated) {
            this.$emit('voiceInitiated');
            this.voice_initiated = false;
          }
          this.$emit('sendMessage', newMessage);
          if(!message)
            this.$refs.messenger_input.innerHTML = '';
        }
      },
      onVoiceTranscribed() {
        this.voice_initiated = true;
      },
      handleInputFocus() {
      },
      getObjectThreads() {
        if (this.object_threads_processing || this.$FUSarrayHasEntries(this.object_threads)) return;
        const self = this;
        this.object_threads_processing = true;
        this.mainStore.GetThreads('user/objectThreads').then(response => {
          self.object_threads = self.$FUSarrayHasEntries(response) ? response : [];
          self.object_threads_processing = false;
        }, () => {
          self.object_threads_processing = false;
        });
      },
    }
  }
</script>
